import { Component, PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { map, chunk } from 'lodash'
import { Row, Col } from 'react-bootstrap'
import Image from 'components/image'
import Link from 'components/link'
import { InfoButton } from 'components/buttons'
import { GOALS } from 'registry/constants'
import { saveRegistryUIState } from 'registry/actions'
import { getRegistrySetupGoalIsCompleted } from 'registry/reducers'
import DismissableModalButton from 'registry/components/dismissable-modal-button'
import { cashFundFAQPath, pdpPath } from 'lib/urls'

class AddCashFund extends Component {
  static propTypes = {
    dismissed: PropTypes.bool,
    onSaveDismissed: PropTypes.func.isRequired,
    cashFunds: PropTypes.arrayOf(PropTypes.object).isRequired,
  }

  render() {
    return (
      <div>
        <CashFunds cashFunds={this.props.cashFunds} className="mbl" />
        <DismissableModalButton
          dismissText="I don't want to add a cash fund right now."
          dismissed={this.props.dismissed}
          onSaveDismissed={this.props.onSaveDismissed}
        />
      </div>
    )
  }
}

export class CashFunds extends PureComponent {
  static propTypes = {
    cashFunds: PropTypes.arrayOf(PropTypes.object).isRequired,
    className: PropTypes.string,
  }

  render() {
    return (
      <div className={this.props.className}>
        <p className="mbl">
          Cash funds are great for big expenses like a doula, cloth diapering
          service or to kick start the college fund. They are also the perfect
          way to let multiple people contribute to a big ticket item.{' '}
          <Link newWindow url={cashFundFAQPath}>
            Learn more.
          </Link>
        </p>
        {map(chunk(this.props.cashFunds, 2), (fundsChunk, idx) => {
          return (
            <Row
              className="grid-border-between grid-border-between-sm grid-border-between-full-gutter grid--borderAbove grid--borderAbove-sm"
              key={idx}
            >
              {map(fundsChunk, (fund) => {
                return (
                  <Col sm={6} key={fund.id}>
                    <Row className="pbl ptl">
                      <Col sm={6} xs={5}>
                        <Image
                          className="bas img-responsive"
                          src={fund.imageUrl}
                          alt={fund.name}
                        />
                      </Col>
                      <Col sm={6} xs={7}>
                        {fund.brand ? (
                          <div className="h7 mvs text-uppercase">
                            {fund.brand}
                          </div>
                        ) : null}
                        <div className="h4 mts">{fund.name}</div>
                        <InfoButton
                          block
                          className="btn-empty"
                          href={fund.path}
                          size="small"
                        >
                          Select
                        </InfoButton>
                      </Col>
                    </Row>
                  </Col>
                )
              })}
              {
                /* fix border when odd number of funds */
                fundsChunk.length === 1 ? (
                  <Col sm={6} className="hidden-xs" />
                ) : null
              }
            </Row>
          )
        })}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    dismissed: getRegistrySetupGoalIsCompleted(state, GOALS.cashFund),
  }
}

export default connect(mapStateToProps, {
  onSaveDismissed: saveRegistryUIState.bind(null, {
    dismissedAddCashFund: true,
  }),
})(AddCashFund)
